import React from "react";

function ImportantNotes({ Notes }) {
  return (
    <ul className="ul-a">
      {Notes.map((note) => (
        <li
          className="pb-2"
          key={Math.random()}
          dangerouslySetInnerHTML={{
            __html: note.text,
          }}
        />
      ))}
    </ul>
  );
}

export default ImportantNotes;
